import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { SkeletonPage } from './skeleton-page.model';

@Component({
    selector: 'ms-skeleton-main-desktop',
    templateUrl: './skeleton-main-desktop.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SkeletonMainDestopComponent {
    @Input() pageName: SkeletonPage;
    skeletonPage = SkeletonPage;
    constructor(public device: DeviceService) {}
}
